import { ideasState } from '../../state'
import { useRecoilValue } from 'recoil'
import { useParams } from 'react-router-dom'

const useIdea = () => {
  const { ideaId } = useParams<{ ideaId: string }>()
  const { data, loading } = useRecoilValue(ideasState)

  return {
    loading,
    data: data?.find(idea => idea.id === ideaId)
  }
}

export default useIdea
